import React from 'react';

const DEVICES = {
  phone: 'phone',
  watch: 'watch',
} as const;

interface Props {
  device: (typeof DEVICES)[keyof typeof DEVICES];
}

export const DeviceIconRenderer = ({ device }: Props) => {
  switch (device) {
    case DEVICES.phone: {
      return (
        <svg
          width="34"
          height="70"
          viewBox="0 0 34 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="1.5" y="1.5" width="31" height="67" rx="5.5" fill="white" />
          <rect
            x="1.5"
            y="1.5"
            width="31"
            height="67"
            rx="5.5"
            stroke="#3A474E"
            strokeWidth="3"
          />
          <rect x="13" y="5" width="8" height="2" rx="1" fill="#3A474E" />
        </svg>
      );
    }

    case DEVICES.watch: {
      return (
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="94.000000pt"
          height="180.000000pt"
          viewBox="0 0 94.000000 180.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)"
            fill="#3A474E"
            stroke="none"
          >
            <path
              d="M170 1785 c-7 -8 -21 -93 -32 -187 -10 -95 -21 -179 -23 -185 -2 -7
-18 -13 -35 -13 -17 0 -39 -9 -50 -20 -19 -19 -20 -33 -20 -478 0 -512 -4
-482 71 -496 l36 -6 20 -185 c11 -105 26 -191 33 -200 11 -13 54 -15 299 -15
157 0 292 4 299 9 9 5 20 72 34 200 l22 191 38 7 c70 11 68 -5 68 500 0 440
-1 454 -20 473 -11 11 -33 20 -50 20 -17 0 -33 6 -35 13 -2 6 -13 90 -23 185
-11 94 -25 179 -32 187 -19 22 -581 22 -600 0z m568 -157 c7 -62 15 -137 18
-165 l7 -53 -293 0 -293 0 6 43 c3 23 11 97 18 165 l13 122 256 0 256 0 12
-112z m132 -722 l0 -433 -31 -7 c-41 -8 -697 -8 -738 0 l-31 7 0 433 0 434
400 0 400 0 0 -434z m-113 -558 c-3 -24 -11 -98 -18 -165 l-13 -123 -256 0
-256 0 -12 113 c-7 61 -15 136 -18 165 l-7 52 293 0 293 0 -6 -42z"
            />
          </g>
        </svg>
      );
    }

    default: {
      return null;
    }
  }
};
